import { render, staticRenderFns } from "./AlertsPanel.vue?vue&type=template&id=f4ba3c60&"
import script from "./AlertsPanel.vue?vue&type=script&lang=js&"
export * from "./AlertsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports